import { Box, Paper } from '@mui/material';
import WidgetHeading from './WidgetHeading';
import { BetaFlag } from 'components/generic/BetaFlag';
import { TDashboardContext, useDashboardContext } from 'screens/dashboard/Dashboard';
import DashboardControls from './DashboardControls';

type TDashboardHeaderProps = {
  isChild?: boolean;
  dashboardTitleHeight: number;
  isBeta?: boolean;
  dashboard?: TDashboardContext['dashboard'];
};

export const DashboardHeader = ({
  isChild,
  isBeta,
  dashboard,
}: TDashboardHeaderProps) => {
  const { filtersReady } = useDashboardContext();

  return (
    <Paper
      className="dashboard-header"
      data-testid="dashboard-header"
      sx={{
        display: isChild ? 'none' : 'grid', // Hides the header in KpiBar dashboards.
        width: '100%',
        px: 2,
        py: 0,
        borderRadius: 0,
        gridTemplateColumns: {
          xs: '2fr 1fr',
          md: '1fr 2fr',
        },
        position: 'sticky',
        top: 0,
        zIndex: 999,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        boxShadow: 0,
      }}
    >
      <WidgetHeading sx={{ py: 1.5 }}>
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {isBeta && <BetaFlag fontSize="medium" />}
          {dashboard?.title}
        </Box>
      </WidgetHeading>

      {/* Only render DashboardControls when filters are available. */}
      {filtersReady && <DashboardControls />}
    </Paper>
  );
};

export default DashboardHeader;
